var __importDefault = (this && this.__importDefault) || function (mod) {
  return (mod && mod.__esModule) ? mod : { "default": mod };
};
export const styles = {
    root: {
        backgroundColor: '#FFFFFF',
        paddingTop: '10px',
        paddingLeft: '50px',
        height: '100%',
        width: '100%',
    },
    elem: {
        fontFamily: 'Segoe UI',
        fontSize: '24px',
    },
    dataGridStyles: {
        root: {
            '.datagrid-class': {
                padding: '15px',
                height: '560px',
            },
            '.ms-DetailsRow-cell': {
                border: '1px solid lightgrey',
            },
            '.ms-DetailsHeader-cellTitle': {
                border: '1px solid lightgrey',
            },
        },
        ['data-item-key=actions']: {
            width: '100px',
        },
    },
    emptyStateStyles: {
        root: {
            paddingBottom: '144px',
        },
    },
    emptyDataGridStyles: {
        root: {
            '.datagrid-class': {
                padding: '15px',
                height: '560px',
            },
            '.ms-DetailsRow-cell': {
                border: '1px solid lightgrey',
            },
            '.ms-DetailsHeader-cellTitle': {
                border: '1px solid lightgrey',
            },
        },
        ['data-item-key=actions']: {
            width: '100px',
        },
    },
};
export const headerStyle = {
    root: {
        selectors: {
            '.ms-DetailsHeader-cellName': {
                fontSize: 19,
                fontWeight: 600,
            },
        },
    },
};
export const weekHeaderStyle = {
    root: {
        selectors: {
            '.ms-DetailsHeader-cellName': {
                fontSize: 14,
                fontWeight: 600,
                paddingLeft: 20,
            },
        },
    },
};
//# sourceMappingURL=GridViewComponent.styles.js.map